import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/play.svg'


const _withScopeId = n => (_pushScopeId("data-v-28c55c9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "draggable", "ondragstart"]
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  draggable: false,
  alt: "play"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]

import { useStorePuzzle } from '@/stores/puzzle'
import { PuzzleVideo } from '@/types/Puzzle'


export default /*#__PURE__*/_defineComponent({
  props: {
    puzzleVideo: null,
    draggable: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  puzzleVideo: PuzzleVideo | null
  draggable: boolean
}



const puzzleStore = useStorePuzzle()

function onPlayClick(dataVideoId: string) {
  puzzleStore.setCurrentVideoId(dataVideoId)
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function drag(ev: any) {
  ev.dataTransfer.setData('text/plain', ev.target.id)
}

return (_ctx: any,_cache: any) => {
  return (props.puzzleVideo)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "puzzle-video-card",
        id: `${props.puzzleVideo.id}`,
        draggable: props.draggable,
        ondragstart: props.draggable && drag
      }, [
        _createElementVNode("img", {
          class: "puzzle-video-card-poster",
          src: props.puzzleVideo.poster,
          draggable: false,
          alt: "puzzle-video-card-poster"
        }, null, 8, _hoisted_2),
        _createElementVNode("button", {
          class: "btn btn-play",
          draggable: false,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (
        props.puzzleVideo && onPlayClick(_ctx.$t(props.puzzleVideo.dataVideoId))
      ))
        }, _hoisted_4)
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})